import {Component, Input, OnDestroy, OnInit, HostListener, OnChanges, EventEmitter, Output, ViewEncapsulation}   from '@angular/core'

import {InsaCronService, LocalizeService} from '../../../../insa-services';
import {ChronosJobListColumnDef} from './job-list-columns';
import {InsaChronosJobModel} from '../../../../insa-models';

import {appStateProvider} from '../../../../insa-providers'
//import { window } from 'rxjs/operator/window';

import { Router } from '@angular/router';

import { customGroupHeader, SharedMethodsModule } from '../../../../insa-custom-scripts';
// import { classicNameResolver } from 'typescript';



@Component({ 
    template: require("./job-list.component.html"),
    styles: [require("./job-list.component.css").toString()],
    encapsulation: ViewEncapsulation.Emulated
})
export class ChronosJobListComponent implements OnInit { 
    
    private jobListSubscription;
    private isJobSelected: boolean = false;
    private isJobForDeleteSelected: boolean = false;
    private isJobAddSelected: boolean = false;
    private isChronosJobList: boolean = true;
    private isJobCopySelected: boolean = true;
    //jobSelectedItem:InsaChronosJobModel = new InsaChronosJobModel();
    jobSelectedItem: any;
    // private jobs = new Array<InsaChronosJobModel>();
    private jobs: any;

    _jobID: number = null;
    @Input()  set jobID(jobId: number){
      this._jobID = jobId;
    }

    // @HostListener('window:beforeunload')
    //     redirectOnRefresh() {
    //         this.router.navigate(['/login']);
    //     }

    constructor(private _insaChronService: InsaCronService, private _appStateProvider: appStateProvider, private _localize: LocalizeService, private router: Router) {
        //var that = this;
        // window.onbeforeunload = (e) => {
        //     e.preventDefault();
        //    return that.router.navigate(['/login']);
        // }

    }

    getJobData(){
        this.InitKendoJobGrid(this.createJobGridColumnDefs(), []); 
        this.jobListSubscription =  this._insaChronService.getJob().subscribe((jobdata) => {
            this.jobs = jobdata;
            this.refreshJobList(jobdata);
        });
    }


    private refreshJobList(job: InsaChronosJobModel[]) {
        if (job !== undefined && job !== null && job.length > 0) {
            this.InitKendoJobGrid(this.createJobGridColumnDefs(), job);
        } else {
            this.InitKendoJobGrid(this.createJobGridColumnDefs(), []);
        }
    }

    private createJobGridColumnDefs() {

        let jobListColumnDefs = new Array<ChronosJobListColumnDef>();
        
        jobListColumnDefs.push(new ChronosJobListColumnDef("JobID", "JobID", true)); //, '#:(JobID!==null) ? JobID : "" #'
        jobListColumnDefs.push(new ChronosJobListColumnDef("Name", "Name")); //, '#: (Name!==null)? Name : ""#'
        jobListColumnDefs.push(new ChronosJobListColumnDef("Description", "Description")); //, '#: (Description!==null)? Description : ""#'
        jobListColumnDefs.push(new ChronosJobListColumnDef("CRONExpression", "CRON Expression")); //, '#: (CRONExpression!==null) ? CRONExpression : "" #'

        return jobListColumnDefs;
    }

    private getJobFromRow(e) {
        e.preventDefault();

        let jobList: kendo.ui.Grid = $("#ChronosJobList").data("kendoGrid");
        let tr = $(e.target).closest("tr");

        //get selected button action by Id
        let target = e.target || e.srcElement || e.currentTarget;
        let idAttr = target.attributes.id;
        let actionValue = idAttr.nodeValue;

        switch (actionValue) {
            case "editJobBtn": {
                this.isJobSelected = true;
                this.jobSelectedItem = jobList.dataItem(tr);
                this.isChronosJobList = false;
                break;
            }
            case "copyJobBtn": {
                this.isJobCopySelected = true;
                this.jobSelectedItem = jobList.dataItem(tr);
                this.isChronosJobList = false;
                break;
            }
            case "deleteJobBtn": {
                this.isJobForDeleteSelected = true;
                let jobSelectedItem: any = jobList.dataItem(tr);
                this.jobID = jobSelectedItem.JobID;
                break;
            }
            default: {
                console.log("");
                break;
            }
        }
    }


    private deleteJob(e) {
        this._insaChronService.deleteJob(this._jobID).subscribe(d =>
            this.getJobData()
        );
    }

    private addNewJob(evt) {
        this.isJobAddSelected = true;
        this.jobSelectedItem = new InsaChronosJobModel();
        this.isChronosJobList = false;
    }

    editJob(editedJobItem) {
        this.jobID = editedJobItem.JobID;
    }

    private onResize(event) {
        let jobGrid: kendo.ui.Grid = $("#ChronosJobList").data("kendoGrid");
        if (jobGrid !== undefined) {
            jobGrid.options.height = $(".gridResize").height();
            jobGrid.resize();
        }
    }

 private InitKendoJobGrid(columnDefs, griddata) {
    
      let dataSourceOptions: kendo.data.DataSourceOptions = {};
      dataSourceOptions.data = griddata;
      dataSourceOptions.schema = {
          model: {
              JobID: {type: "number"},
              fields: {
                  Description: {type:"string"},
                  Name: {type:"string"},
                  CronExpression: {type:"string"}
              }
          }
      };
 
     let dataSource: kendo.data.DataSource = new kendo.data.DataSource(dataSourceOptions);
    columnDefs.push({width:15, height: 20, command: [ 
        { name: "editJobBtn",
                 //text:'EDIT',
                 className: 'k-icon k-i-edit',
                 click: this.getJobFromRow.bind(this),
             }
         ]
     });
     columnDefs.push({
        width: 15, height: 20, command: [
            {
                name: "copyJobBtn",
                //text:'EDIT',
                className: 'k-icon k-i-copy',
                click: this.getJobFromRow.bind(this),
            }
        ]
    });
     columnDefs.push({
         width: 15, command: [
             {
                 name: "deleteJobBtn",
                 //text:'DELETE',
                 className: 'k-icon k-i-delete',
                 click: this.getJobFromRow.bind(this),
             }
         ]
     });
     
    let jobGrid: kendo.ui.Grid = $("#ChronosJobList").data("kendoGrid");
   
    if (jobGrid === undefined){
      let jobGridOptions: kendo.ui.GridOptions = {};
      jobGridOptions.dataSource = dataSource;
      jobGridOptions.filterable = false;
      //jobGridOptions.height = '100%';
      jobGridOptions.sortable = true;
      jobGridOptions.selectable = true;
      jobGridOptions.reorderable = true;
      jobGridOptions.scrollable = true;
      jobGridOptions.noRecords = { template: SharedMethodsModule.noDataTemplate() };
      jobGridOptions.groupable = true;
      jobGridOptions.group = function(e){
        if(e.groups!==undefined && e.groups!==null){
           let lastSavedGrouping = e.groups;
           localStorage.setItem('jobGridGrouping', JSON.stringify(lastSavedGrouping));
        }
      };
      jobGridOptions.sort = function(e) {
        if (e.sort!== undefined && e.sort!==null) {
         let lastSavedSorting = e.sort;
         localStorage.setItem('jobGridSorting', JSON.stringify(lastSavedSorting));
        }
      };
      jobGridOptions.pageable = false;
      jobGridOptions.resizable = true;
      jobGridOptions.columns = columnDefs;

      jobGridOptions.dataBound = customGroupHeader.KendoGridDataBound;

      $("#ChronosJobList").kendoGrid(jobGridOptions);
      jobGrid = $("#ChronosJobList").data("kendoGrid");
    }
    else {
        jobGrid.options.filterable = false;
        jobGrid.setDataSource(dataSource);        
    }  
  }

  getNewJobList(event){
    console.log(event)
    this.hideModal();
    this.getJobData();
  }

  hideModal(){
    this.isJobSelected = false;
    this.isJobForDeleteSelected = false;
    this.isJobAddSelected = false;
    this.isJobCopySelected = false;
    this.isChronosJobList = true;
  }

 ngAfterViewInit() { }

 ngOnInit() {
    kendo.ui.progress($(".jobGrid-loading"), this._appStateProvider.fetchingChronosJob);
    this.getJobData();
 }
}


// WEBPACK FOOTER //
// ./app/insa-components/insa-cron/insa-job/insa-job-list/job-list.component.ts